import React from "react";

import "./__styles__/Icon.scss";

const CaretDown = () => {
  return (
    <svg
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1.43408L5 5.55508L9 1.43408"
        stroke="#0C111B"
        strokeWidth="1.15"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CaretDown;
